module.exports = __webpack_public_path__ + "img/合约发布结果查询.ef63858f.jpg";